module.exports = {
  registerPaths: {
    register: () => '/register',
    resendEmail: () => '/register/resend-email',
    confirmEmail: () => '/register/confirm/:token',
  },
};
